import { FormEntry } from "components";
import { Fragment, useEffect, useState } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { Button } from "reactstrap";

export const FifthPage = ({ register, errors, studentPrefix, setStudentPrefix, watch, control }) => {
	const {
		fields: classQuestions,
		append,
		remove: removeClassQuestion,
	} = useFieldArray({
		control,
		name: `studentReport.${studentPrefix}.classQuestions`,
	});

	useEffect(() => {
		setStudentPrefix(studentPrefix);
		appendClassQuestion();
	}, []);

	const appendClassQuestion = () => {
		append({
			question: undefined,
			answer: undefined,
		});
	};

	return (
		<>
			{classQuestions.map((classQuestion, index) => (
				<Fragment key={classQuestion.id}>
					<div className="d-flex justify-content-end align-items-center mb-1 text-danger">
						<span
							className="btn btn-link btn-danger py-1 border-danger border"
							onClick={() => removeClassQuestion(index)}
							style={{ cursor: "pointer" }}
						>
							<FiX className="mr-1" size={20} />
							Remove
						</span>
					</div>
					<FormEntry
						register={register}
						prefix={"studentReport." + studentPrefix}
						placeholder="Question"
						formLabel={`Question ${index + 1}`}
						type="text"
						name={`classQuestions.${index}.question`}
						required={true}
						error={errors.studentReport?.[studentPrefix]?.classQuestions?.[index]?.question}
					/>
					<FormEntry
						register={register}
						prefix={"studentReport." + studentPrefix}
						placeholder="Answer"
						formLabel={`Answer ${index + 1}`}
						type="text"
						name={`classQuestions.${index}.answer`}
						required={true}
						error={errors.studentReport?.[studentPrefix]?.classQuestions?.[index]?.answer}
					/>
				</Fragment>
			))}
			<div className="d-flex justify-content-end mb-4">
				<Button
					color="info"
					size="sm"
					onClick={() =>
						appendClassQuestion({
							performance: undefined,
							name: undefined,
							custom: true,
						})
					}
				>
					Add Question
				</Button>
			</div>
		</>
	);
};
